
import u from "umbrellajs"
import Promise from "plugins/bluebird"

import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"


const INIT_DONE_CLASS = "js-intl-tel-input--init-done"


function getIntlTelInput() {
  return Promise.resolve(
    import(
      "intl-tel-input"
    )
    .then((module) => module.default)
  )
}

const init = (selector: string = ".js-intl-tel-input"): Promise<void> => {
  return getIntlTelInput()
  .then((intlTelInput) => {
    u(selector).each((el) => {
      if (! (el instanceof HTMLInputElement)) { return }

      if (el.classList.contains(INIT_DONE_CLASS)) { return }

      intlTelInput(el, {
        allowDropdown:    true,
        autoInsertDialCode: true,
        autoPlaceholder:  "polite",
        nationalMode:     false,
        // `separateDialCode: true` requires custom JS
        // to handle submission of country code
        // Thus unsafe to set it as `true`
        // since simple pages like /zh-tw/my/settings
        // are bugged (not saving country code)
        separateDialCode: false,

        initialCountry:     "auto",
        preferredCountries: [
          "hk",
          "tw",
          "cn",
          "mo",
          "jp",
          "us",
          "gb",
        ],

        geoIpLookup: (callback: (c: string) => void) => {
          q_ajax_3({
            url:      "/my_country_code",
            method:   "GET",
            dataType: "json",
          })
          .then(({data}) => {
            const countryCode = (data?.country_code) ? data.country_code : ""
            callback(countryCode)
          })
          .catch(() => {
            // Do nothing
          })
          .done()
        },
      })

      // On focus move the cursor to the end
      el.addEventListener("focus", () => {
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
        if (!("setSelectionRange" in el)) { return }

        // Timeout is required
        // Since the cursor seems to be moved to where the pointer clicks
        // after the event listeners
        setTimeout(() => {
          el.setSelectionRange(9999, 9999, "forward")
        }, 0)
      })

      el.classList.add(INIT_DONE_CLASS)
    })
  })
}

export default {
  init,
  getIntlTelInput,
}
